import { lazy, ComponentType } from 'react';

export function lazyRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
  name = 'chunk',
  maxRetries = 3,
  interval = 1000
) {
  return lazy(() => {
    return new Promise<{ default: T }>((resolve, reject) => {
      const hasRefreshed = JSON.parse(
        window.sessionStorage.getItem(`retry-${name}`) || 'false'
      );

      const attemptImport = (retriesLeft: number) => {
        componentImport()
          .then(resolve)
          .catch((error) => {
            if (retriesLeft > 0) {
              setTimeout(() => {
                attemptImport(retriesLeft - 1);
              }, interval);
            } else if (!hasRefreshed) {
              window.sessionStorage.setItem(`retry-${name}`, 'true');
              window.location.reload();
            } else {
              window.sessionStorage.removeItem(`retry-${name}`);
              reject(error);
            }
          });
      };

      attemptImport(maxRetries);
    });
  });
}
